module.exports = __webpack_public_path__ + "img/IMG_3468.abd5000e.jpg";